module.exports = __webpack_public_path__ + "img/top_bar.01b39ddf.svg";